export default "__VITE_ASSET__CPFhimhm__"